import RootWrapper from "./src/components/ui/root-wrapper";
export const wrapRootElement = RootWrapper